
import store from '../store';
import Constants from '../config/constants';
import {serviceCreateReward, serviceGetReward, serviceUpdateReward,serviceDeleteReward, serviceGetSubsriptionList} from "../services/Reward.service";

export const FETCH_INIT = 'FETCH_INIT_REWARD';
export const FETCHED = 'FETCHED_REWARD';
export const FETCHED_FAIL = 'FETCHED_FAIL_REWARD';
export const FETCHED_FILTER = 'FETCHED_FILTER_REWARD';
export const FETCH_NEXT = 'FETCH_NEXT_REWARD';
export const FILTER = 'FILTER_REWARD';
export const RESET_FILTER = 'RESET_FILTER_REWARD';
export const SET_SORTING = 'SET_SORTING_REWARD';
export const SET_FILTER = 'SET_FILTER_REWARD';
export const SET_PAGE = 'SET_PAGE_REWARD';
export const CHANGE_PAGE = 'CHANGE_PAGE_REWARD';
export const CHANGE_STATUS= 'CHANGE_STATE_REWARD';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_REWARD';
export const CREATE_DATA = 'CREATE_REWARD';
export const UPDATE_DATA = 'UPDATE_REWARD';
export const DELETE_ITEM = 'DELETE_REWARD';
export const DRAG_ITEM = 'DRAG_REWARD';

export function actionFetchReward(index = 1, sorting = {}, filter = {}, shouldReset=false) {
    const request = serviceGetReward({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}

export function actionFetchSubscription(index = 1, sorting = {}, filter = {}, shouldReset=false) {
    const request = serviceGetSubsriptionList({ index, row: sorting.row, order: sorting.order, ...filter });
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: SET_FILTER, payload: filter});
            dispatch({type: SET_SORTING, payload: sorting});
            if (!data.error) {
                dispatch({type: FETCHED, payload: { data: data.data, page: index }});
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({type: CHANGE_PAGE, payload: index - 1});
                }
            } else {
                dispatch({type: FETCHED_FAIL, payload: null});
            }
        });
    };
}

export function actionCreateReward(data) {
    const request = serviceCreateReward(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                dispatch({type: CREATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionUpdateReward(data) {
    const request = serviceUpdateReward(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                dispatch({type: UPDATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionDeleteReward(id) {
    const request = serviceDeleteReward({ id: id});
    return (dispatch) => {
        dispatch({type: DELETE_ITEM, payload: id})
    }
}


export function actionChangePageRewardRequests(page) {
    return (dispatch) => {
        dispatch({type: CHANGE_PAGE, payload: page})
    }
}

export function actionFilterReward(value) {
    const request = null;////serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: FETCH_INIT, payload: null});
        request.then((data) => {
            dispatch({type: FILTER, payload: data});
            dispatch({type: FETCHED, payload: null});//dispatch function
        });
    };
}


export function actionChangeStatusReward(id, status) {
    // const request = serviceFetchProviderRequests(value);
    return (dispatch) => {
        dispatch({type: CHANGE_STATUS, payload: {id, status}});
    };
}

export function actionResetFilterReward() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionDragReward(dragId, dragOverId) {
    return {
        type: DRAG_ITEM,
        payload: {dragId, dragOverId}
    }
}

export function actionSetPageReward(page) {
    const stateData = store.getState().reward;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(actionFetchReward(serverPage + 1, sortingData, {query, query_data: queryData}));
    }


    return {
        type: CHANGE_PAGE,
        payload: page,
    };

}
